import { createApp } from 'vue';
import App from '@/App.vue';
import createRouter from '@/router';
import store from '@/store';
import { i18n } from '@/language';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

require('@/assets/scss/main.scss');
require('@/assets/scss/media.scss');

const app = createApp(App);

library.add(fas, far, fal, fab);
app.component('fa-icon', FontAwesomeIcon);

app.config.productionTip = false;

app.use(store);

const router = createRouter(store);

app.use(router);
app.use(i18n);

app.mount('#app');
